var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcRegularDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 8H17.625V4H3.625C2.525 4 1.625 4.9 1.625 6V17H3.625C3.625 18.66 4.965 20 6.625 20C8.285 20 9.625 18.66 9.625 17H15.625C15.625 18.66 16.965 20 18.625 20C20.285 20 21.625 18.66 21.625 17H23.625V12L20.625 8ZM6.625 18.5C5.795 18.5 5.125 17.83 5.125 17C5.125 16.17 5.795 15.5 6.625 15.5C7.455 15.5 8.125 16.17 8.125 17C8.125 17.83 7.455 18.5 6.625 18.5ZM20.125 9.5L22.085 12H17.625V9.5H20.125ZM18.625 18.5C17.795 18.5 17.125 17.83 17.125 17C17.125 16.17 17.795 15.5 18.625 15.5C19.455 15.5 20.125 16.17 20.125 17C20.125 17.83 19.455 18.5 18.625 18.5Z",
    fill: "#98A5B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRegularDelivery);
export default __webpack_public_path__ + "static/media/ic_regular_delivery.cd6a8ab91cff2dc73ce532c8522a5539.svg";
export { ForwardRef as ReactComponent };